<template lang="html">
  <div class="search-header">
       <div class="v-header">
         <span class="back" @click="goback()">
           <slot name="name1"></slot>
         </span>
         <span class="address" v-show="isRight">
           澳门
           <span class="pull">
             <img src="./../assets/common/common_btn_down@2x.png" alt="">
           </span>
         </span>
         <div class="search-box" :style="`width:${swidth}%`" :class="{'rt':isRight}" @click="$router.push({name: 'searchPage'})">    
           <input v-if="isRight" class="input" type="search" v-model="keywords" placeholder="输入搜索关键词" >
           <input v-else class="input input2" type="search" v-model="keywords" placeholder="输入搜索关键词" v-focus>
            <span class="icon search">
             <img src="./../assets/common/common_icon_search@2x.png" alt="">
           </span> 
           <span class="icon cross" v-show="isFocus">
             <img src="./../assets/common/common_btn_del-gray@2x.png" alt="" @click="clear">
           </span>      
         </div>
        <span class="button">
            <slot name="name3"></slot>
        </span>
      </div>
  </div>
</template>

<script>
export default {
  name: "searchHeader",
  props: ['swidth','isRight'],
  data() {
    return {
      keywords: "",
      isFocus: false
    };
  },
  directives: {
  focus: {
    // 指令的定义
    inserted: function (el) {
      el.focus()
    }
  }
},
  watch: {
    keywords(val,oldVal) {
      if(val) {
        this.isFocus = true;
      }else {
        this.isFocus = false;
      }
    }
  },
  created() {},
  methods: {
    clear() {
      this.keywords = '';
    },
    goback() {
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="css" scoped>
.rt {
  float: right;
}
.search-header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background: transparent; */
  background: #fff;
  z-index: 100;
}
.v-header {
  padding: 0.17rem 0.27rem 0.17rem 0.16rem;
  position: relative;
  font-size: 0.36rem;
  text-align: center;
  height: 1.02rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.search-box {
  display: inline-block;
  min-width: 80%;
  margin: 0 auto;
  position: relative;
  height: 0.68rem;
  /* background: #fff; */
}
.icon {
  position: absolute;
  display: inline-block;
  top: 0.2rem;
  width: 0.3rem;
  height: 0.3rem;
}
.search {
    left: 0.29rem;
}
.cross {
  right: .29rem;
}
.icon > img {
  display: block;
  width: 100%;
  height: 100%;
}
.input {
  background: #fff;
  position: absolute;
  border-radius: 1rem;
  padding: 0.18rem 0.8rem;
  width: 100%;
  left: 0;
  font-size: 0.26rem;
  color: #999;
  /* height: 0.48rem; */
  /* line-height: 0.48rem; */
  /* border-color: transparent; */
   border: .02rem solid transparent;
}
.input {
  border: .02rem solid #aaa;
}
input[type="search"] {
  -webkit-appearance: textfield;
  /* -webkit-box-sizing: content-box; */
  /* font-family: inherit; */
  /* outline: none; */

  /* padding: .18rem .1rem; */
}
input::-webkit-search-decoration {
  display: none;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  /* position: relative;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url('./../assets/common/common_btn_del-gray@2x.png')   */
}

input[type="search"]::-webkit-search-cancel-button:after {
  /* position: absolute;
    content: 'x';
    font-size: 20px;
    color: red; */
}
.v-header > span {
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.back {
  width: 0.4rem;
  height: 0.4rem;
  left: 0.16rem;
}
.back img {
  width: 100%;
  height: 100%;
}
.button {
  font-size: 0.28rem;
  color: #777779;
  right: 0.27rem;
}
.address {
  font-size: .28rem;
  left: .3rem;
  /* color: #fff; */
  color: #5a5a5a;
} 
.pull {
  display: inline-block;
  width: .3rem;
  height: .3rem;
  margin: 0 .18rem;
}
.pull img {
  width: 100%;
  height:100%;
}
</style>




// WEBPACK FOOTER //
// src/components/searchHeader.vue